import { render, staticRenderFns } from "./editTestimonialSidebar.vue?vue&type=template&id=04a6e3c4&scoped=true&"
import script from "./editTestimonialSidebar.vue?vue&type=script&lang=js&"
export * from "./editTestimonialSidebar.vue?vue&type=script&lang=js&"
import style0 from "./editTestimonialSidebar.vue?vue&type=style&index=0&id=04a6e3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6e3c4",
  null
  
)

export default component.exports